import React from 'react';
import ReactDatePicker from 'react-datepicker';
import {
  DATE_ONLY_DISPLAY_FORMAT,
  normalizeDatePickerValue,
  toPickerDate
} from '../../utils/dateOnly';

const DATE_TIME_PROPS = [
  'value',
  'dateFormat',
  'showTimeSelect',
  'showTimeSelectOnly',
  'showTimeInput',
  'timeFormat',
  'timeIntervals',
  'minTime',
  'maxTime'
];

// All user-facing date pickers are date-only. Stored business dates use UTC
// boundaries so the selected calendar day is stable in every browser timezone.
export default function DatePicker({ boundary = 'end', onChange, ...props }) {
  const pickerProps = { ...props };
  DATE_TIME_PROPS.forEach(prop => delete pickerProps[prop]);

  return (
    <ReactDatePicker
      {...pickerProps}
      selected={toPickerDate(props.selected)}
      startDate={toPickerDate(props.startDate)}
      endDate={toPickerDate(props.endDate)}
      minDate={toPickerDate(props.minDate)}
      maxDate={toPickerDate(props.maxDate)}
      dateFormat={DATE_ONLY_DISPLAY_FORMAT}
      onChange={(nextValue, event) =>
        onChange?.(normalizeDatePickerValue(nextValue, boundary), event)
      }
    />
  );
}
